import createValidator, { registerType } from 'typecheck.macro';
import { makeExperimentWithData } from '../../common/ExperimentContext/types';

export const AlertBoxExperiment = makeExperimentWithData(
  'TPL-AlertBar-SERP',
  createValidator<AlertBarContents>(),
);

registerType('AlertBarContents');
type AlertBarContents = undefined | { desktop?: AlertBarLayout; mobile?: AlertBarLayout };
type AlertBarLayout = AlertBarLine[];
type AlertBarLine = (string | AlertBarLink)[];
type AlertBarLink = {
  text?: string;
  href?: string;
  target?: string;
};
